import React from "react";

interface SwitchProps {
  checked: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
}

const Switch: React.FC<SwitchProps> = ({ checked, onChange, disabled = false }) => (
  <button
    type="button"
    aria-pressed={checked}
    onClick={() => onChange(!checked)}
    disabled={disabled}
    className={`relative inline-flex items-center h-6 w-12 rounded-full transition-colors focus:outline-none ${
      checked ? "bg-primary-600" : "bg-gray-200"
    } ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
    data-testid="switch"
  >
    <span
      className={`inline-block h-4 w-4 transform bg-white rounded-full transition-transform ml-1 ${
        checked ? "translate-x-6" : "translate-x-0"
      }`}
    />
  </button>
);

export default Switch;
